/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import PlaceholderAvatar from '../../images/placeholder.png'
import EditPencil from '../../images/edit-pencil.svg'
import styles from './index.module.css'

const AdminTable = ({ data, selectAdmin, selectChange }) => {
	//
	const setOnErrorImage = (e) => {
		e.currentTarget.src = PlaceholderAvatar
	}
	const renderAdmins = () => {
		return data.map((admin) => {
			const selectClass = classnames({
				[styles.select]: true,
				[styles.selectRed]: !admin.status,
			})
			return (
				<tr key={`admin-${admin.id}`}>
					<td className={styles.userInfo}>
						<img
							alt='user'
							src={admin.picture || PlaceholderAvatar}
							onError={setOnErrorImage}
							className={styles.userImage}
						/>
						<div className={styles.userName}>{admin.name}</div>
					</td>

					<td>{admin.email}</td>
					<td>
						<select
							onChange={(e) => {
								const val = e.target.value === 'enabled'
								selectChange(admin.id, val)
							}}
							className={selectClass}
							defaultValue={admin.status ? 'enabled' : 'disabled'}
						>
							<option
								value='enabled'
								className={styles.selectBlack}
							>
								Enabled
							</option>
							<option
								className={styles.selectRed}
								value='disabled'
							>
								Blocked
							</option>
						</select>
					</td>
					<td
						onClick={() => selectAdmin(admin)}
						className={styles.editButton}
					>
						<img alt='Edit Pencil' src={EditPencil} />
						Edit
					</td>
				</tr>
			)
		})
	}

	return (
		<div className={styles.horizontalScroll}>
			<table className={styles.userData}>
				<thead>
					<tr>
						<th>Admin</th>
						<th>Email Address</th>
						<th>Status</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>{renderAdmins()}</tbody>
			</table>
		</div>
	)
}

AdminTable.propTypes = {
	data: PropTypes.array.isRequired,
	selectChange: PropTypes.func.isRequired,
	selectAdmin: PropTypes.func.isRequired,
}

export default AdminTable
